import { Container } from '@acies/core';
import { Spacer, theme } from '@acies/ui';
import ListHeaderLabel from '../shared/list-header-label/list-header-label';
import { SCROLLBAR_WIDTH } from '../shared/scrollbar-width';

export default class AnswersListHeader extends Container {
	#answerLabel!: ListHeaderLabel;
	#nameLabel!: ListHeaderLabel;
	#valueLabel!: ListHeaderLabel;
	#targetLabel!: ListHeaderLabel;
	#sideLabel!: ListHeaderLabel;
	#statusLabel!: ListHeaderLabel;
	#spacer!: Spacer;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 32;
		// the scrollbar's width on the right, so the last column ends where the rows' last column does
		this.paddingHorizontal = [16, 16 + SCROLLBAR_WIDTH];
		this.alignment = 'left';
		this.gapHorizontal = 16;
		this.fill = theme.colors.fill.weak;
		this.cornerRadius = 8;
		this.clipContent = true;
		this.hideScrollbars = true;
	}

	public get answerLabel(): ListHeaderLabel {
		if (!this.#answerLabel) {
			this.#answerLabel = new ListHeaderLabel();
			// no word for the column yet; the label stays, so the column keeps its 32
			this.#answerLabel.text = '';
			this.#answerLabel.width = 32;
		}
		return this.#answerLabel;
	}

	public get nameLabel(): ListHeaderLabel {
		if (!this.#nameLabel) {
			this.#nameLabel = new ListHeaderLabel();
			this.#nameLabel.text = 'Navn';
			this.#nameLabel.width = 'fill';
		}
		return this.#nameLabel;
	}

	public get valueLabel(): ListHeaderLabel {
		if (!this.#valueLabel) {
			this.#valueLabel = new ListHeaderLabel();
			this.#valueLabel.text = 'Værdi';
			this.#valueLabel.width = 208;
		}
		return this.#valueLabel;
	}

	public get targetLabel(): ListHeaderLabel {
		if (!this.#targetLabel) {
			this.#targetLabel = new ListHeaderLabel();
			this.#targetLabel.text = 'Type';
			this.#targetLabel.width = 64;
		}
		return this.#targetLabel;
	}

	public get sideLabel(): ListHeaderLabel {
		if (!this.#sideLabel) {
			this.#sideLabel = new ListHeaderLabel();
			this.#sideLabel.text = 'Side';
			this.#sideLabel.width = 72;
		}
		return this.#sideLabel;
	}

	public get statusLabel(): ListHeaderLabel {
		if (!this.#statusLabel) {
			this.#statusLabel = new ListHeaderLabel();
			this.#statusLabel.text = 'Status';
			this.#statusLabel.width = 48;
			this.#statusLabel.textAlignHorizontal = 'center';
		}
		return this.#statusLabel;
	}

	public get spacer(): Spacer {
		if (!this.#spacer) {
			this.#spacer = new Spacer();
			this.#spacer.width = 18;
		}
		return this.#spacer;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.answerLabel, this.nameLabel, this.valueLabel, this.targetLabel, this.sideLabel, this.statusLabel, this.spacer]);
	}
}
customElements.define('ac-answers-list-header', AnswersListHeader);
